import createIcon from '../../createIcon';

/**
 * @component @name SaveAs
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNzk5OCAxMS40VjZMMTUuNzk5OCAySDMuNzk5OEMyLjY4OTggMiAxLjc5OTggMi45IDEuNzk5OCA0VjE4QzEuNzk5OCAxOS4xIDIuNjg5OCAyMCAzLjc5OTggMjBIMTEuMTk5OEwxOS43OTk4IDExLjRaTTEzLjc5OTggMTRDMTMuNzk5OCAxNS42NiAxMi40NTk4IDE3IDEwLjc5OTggMTdDOS4xMzk4IDE3IDcuNzk5OCAxNS42NiA3Ljc5OTggMTRDNy43OTk4IDEyLjM0IDkuMTM5OCAxMSAxMC43OTk4IDExQzEyLjQ1OTggMTEgMTMuNzk5OCAxMi4zNCAxMy43OTk4IDE0Wk00Ljc5OTggNUgxMy43OTk4VjlINC43OTk4VjVaTTE4Ljc4OTggMTUuMjVMMjAuNTU5OCAxNy4wMkwxNS41Njk4IDIySDEzLjc5OThWMjAuMjNMMTguNzg5OCAxNS4yNVpNMjIuMDQ5OCAxNS41MUwyMS4xOTk4IDE2LjM2TDE5LjQyOTggMTQuNTlMMjAuMjc5OCAxMy43NEMyMC40Nzk4IDEzLjU0IDIwLjc4OTggMTMuNTQgMjAuOTg5OCAxMy43NEwyMi4wNDk4IDE0LjhDMjIuMjQ5OCAxNSAyMi4yNDk4IDE1LjMyIDIyLjA0OTggMTUuNTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SaveAs = createIcon('SaveAs', [
  [
    'path',
    {
      d: 'M19.7998 11.4V6L15.7998 2H3.7998C2.6898 2 1.7998 2.9 1.7998 4V18C1.7998 19.1 2.6898 20 3.7998 20H11.1998L19.7998 11.4ZM13.7998 14C13.7998 15.66 12.4598 17 10.7998 17C9.1398 17 7.7998 15.66 7.7998 14C7.7998 12.34 9.1398 11 10.7998 11C12.4598 11 13.7998 12.34 13.7998 14ZM4.7998 5H13.7998V9H4.7998V5ZM18.7898 15.25L20.5598 17.02L15.5698 22H13.7998V20.23L18.7898 15.25ZM22.0498 15.51L21.1998 16.36L19.4298 14.59L20.2798 13.74C20.4798 13.54 20.7898 13.54 20.9898 13.74L22.0498 14.8C22.2498 15 22.2498 15.32 22.0498 15.51Z',
      key: '3vmfqt',
    },
  ],
]);

export default SaveAs;
